import React from 'react';
import App from './App';
import ContactUsApp from '../../../jsV2/contactUs/app/ContactUsApp';
import { isNewContactUsExpEnabled } from '../../../jsV2/helpers/twHelper';

const isNewContactUs = isNewContactUsExpEnabled();

const LayoutRenderer = () => {
  const renderOldContactUsLayout = () => <App />;
  const renderNewContactUsLayout = () => <ContactUsApp />;
  const renderContactUsLayout = () => {
    try {
      if (isNewContactUs) {
        // placeholder to return new contact us
        return renderNewContactUsLayout();
      }
      return renderOldContactUsLayout();
    } catch (contactUsRenderError) {
      return renderOldContactUsLayout();
    }
  };
  return renderContactUsLayout();
};

export default LayoutRenderer;
